import { useTranslate } from 'module/hooks/use-translation';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import { Editor } from '@tiptap/core';
import { useMemo } from 'react';
import {
  pickImageFiles,
  uploadAndInsertImages,
} from '../../image/upload-handler';
import { CommandPickerItem } from '../types';
import { CommandListItemIcon } from './common';

export const useGetImageCommand = ({
  documentId,
}: {
  documentId?: number;
}): CommandPickerItem[] => {
  const translate = useTranslate();

  return useMemo(() => {
    if (documentId == null) {
      return [];
    }

    const execute = async (editor: Editor) => {
      const files = await pickImageFiles();

      if (files.length === 0) {
        return;
      }
      const pos = editor.state.selection.from;

      await uploadAndInsertImages(editor, files, documentId, pos);
    };

    return [
      {
        id: 'upload',
        label: translate('editor.commands.upload.title'),
        items: [
          {
            id: 'image',
            label: translate('editor.commands.image.title'),
            icon: <CommandListItemIcon icon={faImage} />,
            execute,
          },
        ],
      },
    ];
  }, [documentId, translate]);
};
